import { useStyletron } from "baseui";
import { IEnergyRate, schemaCostRate, schemaCO2Rate } from "./types";
import { CO2RateListItem, CostRateListItem, DeleteEnergyRateButton, EditEnergyRateButton, SelectableCO2RateListItem, SelectableCostRateListItem } from ".";
import { useGetRelationsOutByIdQuery } from "../../../services/objects";



const EnergyRatesList = (props: { items: IEnergyRate[], selectedItem?: IEnergyRate, onSelect?: (item: IEnergyRate) => void }) => {

    const [css] = useStyletron();

    const handelItemSelected = (item: IEnergyRate) => { if (props.onSelect) props.onSelect(item); };

    const items = props.onSelect ?
        props.items.map((item: any) =>
            <>
                {item.schema === schemaCO2Rate && <SelectableCO2RateListItem onSelect={handelItemSelected} isSelected={props.selectedItem?.id === item.id} key={item.id} {...item} />}
                {item.schema === schemaCostRate && <SelectableCostRateListItem onSelect={handelItemSelected} isSelected={props.selectedItem?.id === item.id} key={item.id} {...item} />}
            </>
        )
        : props.items.map((item: any) =>
            <MyListItem {...item} />
        )
            
    return (
        <ul
            className={css({
                paddingLeft: 0,
                paddingRight: 0,
                minWidth: '350px',
                maxHeight: '600px',
                overflow: "auto"
            })}
        >
            {items}
        </ul>
    )
}

export default EnergyRatesList;

const MyListItem = (props) => {

    const { data: refCounters, isLoading, isSuccess } = useGetRelationsOutByIdQuery({ objectId: props.id, resourceGroupId: props.resourceGroupId, type: 'IsRateOf' })
    const hasRefCounters = refCounters && refCounters.length > 0;
    const item = props;
    return (<>
        {item.schema === schemaCO2Rate && <CO2RateListItem referencedCounters={refCounters?.length} key={item.id} {...item}
            endEnhancers={
                <>
                    <EditEnergyRateButton  {...item}></EditEnergyRateButton>
                    <DeleteEnergyRateButton disabled={hasRefCounters} {...item}></DeleteEnergyRateButton>
                </>
            } />}
        {item.schema === schemaCostRate && <CostRateListItem referencedCounters={refCounters?.length} key={item.id} {...item} endEnhancers={
            <>
                <EditEnergyRateButton  {...item}></EditEnergyRateButton>
                <DeleteEnergyRateButton disabled={hasRefCounters}  {...item}></DeleteEnergyRateButton>
            </>
        } />}
    </>)
}